import { TIPO_DOCUMENTO } from "common/utils/documentos"

export const BTNS_TIPO_DOCUMENTOS = (t: $TSMigrationFixMe) => [
  {
    id: TIPO_DOCUMENTO.FACTURA,
    text: `${t("newDoc.factura.invoiceTitle")}`,
  },
  {
    id: TIPO_DOCUMENTO.ALBARAN,
    text: `${t("newDoc.albaran.deliveryTitle")}`,
  },
  {
    id: TIPO_DOCUMENTO.PEDIDO,
    text: `${t("newDoc.pedido.orderTitle")}`,
  },
  {
    id: TIPO_DOCUMENTO.PRESUPUESTO,
    text: `${t("newDoc.presupuesto.quotationTitle")}`,
  },
]

export const TIPO_DOCUMENTOS_TITLE_SINGLE = (t: $TSMigrationFixMe) => {
  return {
    [TIPO_DOCUMENTO.PRESUPUESTO]: `${t("asociateDoc.quotationLabel")}`,
    [TIPO_DOCUMENTO.PEDIDO]: `${t("asociateDoc.orderLabel")}`,
    [TIPO_DOCUMENTO.ALBARAN]: `${t("asociateDoc.deliveryLabel")}`,
    [TIPO_DOCUMENTO.FACTURA]: `${t("asociateDoc.invoiceLabel")}`,
  }
}

export const getUserModalSelectShape = (
  isComprador: $TSMigrationFixMe,
  contactosBySelect: $TSMigrationFixMe,
  fetchingContactosBySelect: $TSMigrationFixMe,
  getContactosBySelect: $TSMigrationFixMe,
  totalContactos: $TSMigrationFixMe,
  setIsSelectFilterActive: $TSMigrationFixMe,
  handleSelectContacto: $TSMigrationFixMe,
  contacto: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => {
  const userShape = isComprador
    ? {
        title: `${t("newDoc.presupuesto.supplierTitle")}`,
        titlePagosCobros: `${t("newDoc.presupuesto.supplierSubTitle")}`,
        options: contactosBySelect || [],
        placeholder: `${t("newDoc.presupuesto.placeholderSupplier")}`,
        loading: fetchingContactosBySelect,
        fetch: getContactosBySelect,
        userKey: "librador",
        setIsFilterActive: setIsSelectFilterActive,
        totalCount: totalContactos,
        handleSelect: handleSelectContacto,
        value: contacto,
        transactionTypeValue: 2,
      }
    : {
        title: `${t("newDoc.presupuesto.clientTitle")}`,
        titlePagosCobros: `${t("newDoc.presupuesto.clientSubTitle")}`,
        options: contactosBySelect || [],
        placeholder: `${t("newDoc.presupuesto.placeholderClient")}`,
        loading: fetchingContactosBySelect,
        fetch: getContactosBySelect,
        userKey: "librado",
        setIsFilterActive: setIsSelectFilterActive,
        totalCount: totalContactos,
        handleSelect: handleSelectContacto,
        value: contacto,
        transactionTypeValue: 1,
      }

  return userShape
}
